import { Skeleton } from "@mui/material";
import React from "react";

const BlogDetailSkeleton: React.FC = () => {
  return (
    <div>
      <div className="max-w-7xl mx-auto px-[2rem] py-[4rem]">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Left Sidebar */}
          <aside className="lg:col-span-1">
            {/* Back Button Skeleton */}
            <Skeleton
              variant="rectangular"
              width={120}
              height={32}
              className="mb-8 rounded"
            />

            {/* Recommended Blogs Skeleton */}
            <div>
              <Skeleton
                variant="text"
                width={150}
                height={28}
                className="mb-4"
              />
              <div className="space-y-6">
                {[1, 2, 3].map((i) => (
                  <div key={i}>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={160}
                      className="mb-2 rounded-lg"
                    />
                    <Skeleton
                      variant="text"
                      width="90%"
                      height={20}
                      className="mb-1"
                    />
                    <Skeleton
                      variant="text"
                      width="70%"
                      height={20}
                      className="mb-1"
                    />
                    <Skeleton variant="text" width={100} height={16} />
                  </div>
                ))}
              </div>
            </div>
          </aside>

          {/* Main Content */}
          <div className="lg:col-span-3">
            {/* Blog Image Skeleton */}
            <Skeleton
              variant="rectangular"
              width="100%"
              height={480}
              className="mb-8 rounded-lg"
            />

            {/* Blog Title Skeleton */}
            <Skeleton variant="text" width="90%" height={48} className="mb-4" />
            <Skeleton variant="text" width="70%" height={48} className="mb-6" />

            {/* Blog Meta Skeleton */}
            <div className="flex items-center gap-4 mb-6">
              <Skeleton variant="text" width={200} height={20} />
            </div>

            {/* Social Sharing Skeleton */}
            <div className="flex items-center gap-4 mb-8 pb-6 border-b">
              <Skeleton variant="text" width={80} height={20} />
              <div className="flex gap-3">
                {[1, 2, 3, 4].map((i) => (
                  <Skeleton key={i} variant="circular" width={24} height={24} />
                ))}
              </div>
            </div>

            {/* Blog Content Skeleton */}
            <div className="space-y-4">
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="98%" height={24} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="92%" height={24} />
              <div className="my-6">
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={300}
                  className="rounded-lg"
                />
              </div>
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="96%" height={24} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailSkeleton;
